// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { User, Users } from "@phosphor-icons/react";

import { SlidingSegmentedControl } from "../../components/SlidingSegmentedControl";

type AskV2FeedTab = "feed" | "chats";

export function AskV2ProjectTabs({
  active,
  feedLabel,
  chatsLabel,
  viewsLabel,
  onChange,
  "data-testid": dataTestId = "ask-v2-project-tabs",
}: {
  active: AskV2FeedTab;
  feedLabel: string;
  chatsLabel: string;
  viewsLabel: string;
  onChange: (tab: AskV2FeedTab) => void;
  "data-testid"?: string;
}) {
  // why: the breadcrumb trail is items-baseline for text; this 32px pill would sit on that baseline without self-center
  return (
    <div className="flex shrink-0 items-center self-center">
      <SlidingSegmentedControl
        value={active}
        onChange={onChange}
        ariaLabel={viewsLabel}
        data-testid={dataTestId}
        thumbTestId="ask-v2-project-tabs-thumb"
        items={[
          {
            id: "feed",
            testId: "ask-v2-project-feed-tab",
            content: (
              <>
                <Users size={16} aria-hidden="true" />
                {feedLabel}
              </>
            ),
          },
          {
            id: "chats",
            testId: "ask-v2-project-chats-tab",
            content: (
              <>
                <User size={16} aria-hidden="true" />
                {chatsLabel}
              </>
            ),
          },
        ]}
      />
    </div>
  );
}
